import { TaskTracker } from 'components/TaskTracker';
import { Page } from 'layouts/Page';
import { Box } from '@mui/material';
import { FC } from 'react';

export const TaskTrackerPage: FC = () => {
	return (
		<Page title="Task Tracker – EAS Control Center">
			<Box sx={{ maxWidth: 1600, mx: 'auto', width: '100%' }}>
				<TaskTracker />
			</Box>
		</Page>
	);
};
